import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Row, Col } from "antd";
import moment from "moment";
import { AuditLogsData } from "../../../redux/Services/AbhaServices";
import HeadingBack from "../../../component/HeadingBack";
import AbhaLinkedFilter from "../AbhaFilter";

const AuditLogs = () => {
  const filename = "Audit Logs";
  const [auditLogs, setAuditLogs] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [raw, setRaw] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [filter, setFilter] = useState({});
  useEffect(() => {
    getAuditLogs();
  }, [page, limit,filter]);

  useEffect(() => {
    console.log("aauditLogs", auditLogs);
  }, [auditLogs]);

  const getAuditLogs = async () => {
    try {
      const res = await AuditLogsData({ page, limit, ...filter });
      console.log("first", res);
      if (res?.status && Array.isArray(res?.data?.result)) {
        setAuditLogs(res?.data?.result);
        setTotal(res?.data?.dataLength);
      }
    } catch (err) {
      console.error("Failed to fetch audit logs", err);
    }
  };

  const headers = [
    { label: "API Endpoint", key: "api_endpoint" },
    { label: "ABHA Endpoint", key: "abha_endpoint" },
    { label: "Method", key: "method" },
    { label: "IP Address", key: "ip_address" },
    { label: "Status", key: "status" },
    { label: "Time", key: "time" },
    { label: "Query", key: "query" },
    { label: "Requested At", key: "createdAt" },
  ];
  const safeParse = (value) => {
    try {
      let parsed = value;
      while (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      return parsed;
    } catch (e) {
      console.error("Parse error:", e);
      return value; // fallback to raw
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => (page - 1) * limit + index + 1,
    },
    {
      title: "API Endpoint",
      dataIndex: "api_endpoint",
      key: "api_endpoint",
    },
    {
      title: "ABHA Endpoint",
      dataIndex: "abha_endpoint",
      key: "abha_endpoint",
    },
    {
      title: "Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Query",
      render: (_, item) => (
        <Button
          type="primary"
          onClick={() => {
            setRaw(JSON.parse(item?.query || "{}"));
            setModalOpen(true);
          }}
        >
          View
        </Button>
      ),
    },
    {
      title: "Requested At",
      dataIndex: "createdAt",
      render: (val) =>
        moment(val).isValid() ? moment(val).format("DD-MM-YYYY HH:mm:ss") : "-",
    },
    {
      title: "Request",
      render: (_, item) => (
        <Button
          type="primary"
          onClick={() => {
            setRaw(JSON.parse(item?.request));
            setModalOpen(true);
          }}
        >
          View
        </Button>
      ),
    },
    {
      title: "Response",
      render: (_, item) => {
        console.log("item", item);
        return (
          <Button
            type="primary"
            onClick={() => {
              if (item?.response) {
                console.log("Raw Response:", item.response);

                const parsed = safeParse(item.response);
                console.log("Parsed Response:", parsed);

                setRaw(parsed);
                setModalOpen(true);
              }
            }}
          >
            View
          </Button>
        );
      },
    },
  ];

  return (
    <div>
      <Row gutter={[10, 10]} align="middle">
        <Col lg={6} md={12} sm={24} xs={24}>
          <HeadingBack
            title={"Audit Logs"}
            subHeading={`Records ${total || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            FilteredData={auditLogs}
            setFilteredData={setFilteredData}
            filename={filename}
          />
        </Col>
      </Row>

      <div className="tableResponsive mt-10">
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={auditLogs}
          pagination={{
            current: page,
            pageSize: limit,
            total,
            onChange(current, pageSize) {
              setPage(current);
              setLimit(pageSize);
            },
            showSizeChanger: true,
          }}
        />

        <Modal
          style={{ top: 20 }}
          open={modalOpen}
          onOk={() => setModalOpen(false)}
          onCancel={() => setModalOpen(false)}
          footer={null}
          width={800}
        >
          <pre>{JSON.stringify(raw, null, 2)}</pre>
        </Modal>
      </div>
    </div>
  );
};

export default AuditLogs;
